import {
  FontSizes,
  IButtonStyles,
  PrimaryButton,
  Stack,
  Text,
  mergeStyles,
} from "@fluentui/react";
import React, { FC, useEffect, useLayoutEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { HorizontalStack, VerticalStack } from "../../../components/Stack";
import { DocumentVersionInCard } from "../../../components/Cards/DocumentVersionInCard";
import Loader from "../../../components/Loader";
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
import { useTranslation } from "react-i18next";
import { ViewAll } from "../../../components/ViewAll";
import { Document } from "../../../models";
import { colorPallete } from "../../../assets/color";
import HandShakeIcon from "../../../assets/Icons/svg/handshakeIcon";
import SearchIcon from "../../../assets/Icons/svg/searchIcon";
import BoxIcon from "../../../assets/Icons/svg/boxIcon";
import ListIcon from "../../../assets/Icons/svg/listIcon";
import FilterIcon from "../../../assets/Icons/svg/filterIcon";
import "../index.css";
import VersionsListView from "./versionsListView";
import useModal from "../../../hooks/useModal";
import DeleteVersionModal from "../../../components/modals/DeleteVersionModal";
import {
  getDocumentversions,
  getSearchedVersions,
} from "../../../modules/redux/Documents/document";
import ReactPaginate from "react-paginate";
import "./index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getSplitDocumentName, isNearOneMinute } from "../../../utils";
import PrevArrow from "../../../assets/Icons/svg/prevArrow";
import NextArrow from "../../../assets/Icons/svg/nextArrow";
import Slider from "react-slick";

const styles = {
  versionContainer: {
    // height: "27rem",
    // backgroundColor: colorPallete.red,
    width: "99%",
    marginBottom: 20,
    marginTop: "20px",
    paddingLeft: 18,
    paddingTop: 20,
    paddingBottom: 10,
    alignSelf: "center",
    borderRadius: "12px",
    border: "1px solid #DAE0EC",
    background: "linear-gradient(98deg, rgba(236, 240, 249, 0.60) -1.16%, rgba(239, 236, 249, 0.60) 105.83%)",
  },
  versionCard: {
    display: "block",
    width: "99%",
    alignItems: "center",
    justifyContent: "flex-start",
    height: "23rem",
    overflowY: "hidden",
    // backgroundColor: colorPallete.white,
    paddingBottom: "1%",
    paddingTop: "0.5%",
    borderRadius: "1px",
    gap: "20px",
    overflowX: "hidden",
  },
  loaderStyles: {
    display: "flex",
    height: "100%",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  headerStyle: {
    fontSize: "20px",
    color: colorPallete.black1,
    fontWeight: 500,
    paddingLeft: "1%",
    fontFamily: "Poppins",
    lineHeight: "22px",
  },
  DocNameStyle: {
    fontSize: "18px",
    color: colorPallete.grey1,
    fontWeight: 400,
    fontFamily: "Poppins",
  },
  ScrollStyles: {
    height: "10%",
    backgroundColor: "",
    justifyContent: "flex-start",
    zIndex: 2,
    marginBottom: "20px",
  },
  errorStyles: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    height: "18rem",
    alignItems: "center",
    fontFamily: "Poppins",
  },
  listView: {
    border: `2px solid ${colorPallete.btLightBlue}`,
    borderRadius: "0.3rem",
    cursor: "pointer",
    padding: "10px 8px 10px 8px",
    alignItems: "center",
    height: "36px",
    width: "36.049px",
    justifyContent: "center",
  },
  boxView: {
    border: `2px solid ${colorPallete.btLightBlue}`,
    borderRadius: "0.3rem",
    cursor: "pointer",
    padding: "7px",
    alignItems: "center",
    height: "36px",
    width: "36.049px",
    justifyContent: "center",
  },
  filterContainer: {
    height: "150px",
    minWidth: "213px",
    maxWidth: "max-content",
    borderRadius: "4px",
    border: "1px solid #E8ECE4",
    background: "white",
    boxShadow: "0px 12px 16px -4px rgba(0,0,0,0.08)",
    right: 0,
    top: 37,
    justifyContent: "center",
  },
  emptyContainer: {
    display: "flex",
    width: "99%",
    alignItems: "center",
    justifyContent: "center",
    height: "24rem",
  },
  expandedDocumentContainer: {
    width: "100%",
    height: "auto",
    alignItems: "center",
    paddingBottom: "1%",
    paddingTop: "1%",
    paddingRight: "2%",
    flexWrap: "wrap",
    display: "flex",
    backgroundColor: "",
    gap: "20px",
    minHeight: "20rem",
  },
};
const textStyles = mergeStyles({
  fontSize: FontSizes.size24,
  fontFamily: "Poppins",
});

const retryButtonStyles: IButtonStyles = {
  root: {
    width: "20px",
    margin: "1%",
    alignItems: "center",
    fontFamily: "Poppins",
  },
};

const SearchComp = (props: any) => {
  const { t } = useTranslation();
  return (
    <HorizontalStack
      className="SearchComp"
    >
      <HorizontalStack className="searchContainer">
        <SearchIcon />
        <input
          style={{
            width: "100%",
            height: "18px",
            fontFamily: "Poppins",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "16px",
            paddingRight: "10px",
          }}
          value={props.searchText}
          onChange={(e) => props.setSearchText(e.target.value)}
          // onChange={onChangeSearchField}
          placeholder={String(t("search_document_history"))}
          // disabled
        />
      </HorizontalStack>
      <Stack
        style={{
          backgroundColor: props.listView ? colorPallete.btLightBlue : "white",
          ...styles.listView,
        }}
        title={String(t("list_view"))}
        onClick={() => {
          props.setListView(!props.listView);
        }}
      >
        <ListIcon />
      </Stack>
      <Stack
        style={{
          backgroundColor: !props.listView ? colorPallete.btLightBlue : "white",
          ...styles.boxView,
        }}
        onClick={() => {
          props.setListView(!props.listView);
        }}
        title={String(t("box"))}
      >
        <BoxIcon />
      </Stack>
      <Stack
        style={{
          backgroundColor:
            props.filter || props.filterOption !== 0
              ? colorPallete.btLightBlue
              : "white",
          position: "relative",
          ...styles.boxView,
        }}
        title={String(t("filter"))}
        onClick={() => {
          props.setFilter(!props.filter);
        }}
      >
        <FilterIcon />
        {props.filterOption !== 0 ? <Stack className="redDot"></Stack> : null}
      </Stack>
      {props.filter ? (
        <Stack
          style={{
            ...styles.filterContainer,
            position: "absolute",
          }}
        >
          {props.filterOptions.map((item: any, i: any) => {
            return (
              <Text
                key={item}
                className="filterItem"
                onClick={() => {
                  props.setFilterOption(i);
                  props.setFilter(!props.filter);
                }}
                style={{
                  backgroundColor:
                    props.filterOption == i ? colorPallete.btLightBlue : "",
                }}
              >
                {item}
              </Text>
            );
          })}
        </Stack>
      ) : null}
    </HorizontalStack>
  );
};

const LoaderJSX = () => {
  return (
    <Stack className={mergeStyles(styles.loaderStyles)}>
      <Loader />
    </Stack>
  );
};

const VersionBox: React.FC<{
  index: number;
  version: Document;
  versionState: any;
  setDeleteversion: any;
  showModal: any;
  projectData: any;
}> = ({
  index,
  version,
  versionState,
  showModal,
  setDeleteversion,
  projectData,
}) => {
  return (
    <motion.div
      animate={{
        translateX: 0,
        transition: {
          duration: index === 0 ? 0.8 : 0.6,
          delay: index === 0 ? 0.5 : 0,
        },
        scale: 1,
      }}
      initial={{
        translateX: index !== 0 ? -240 : 0,
        scale: index === 0 ? 0 : 1,
      }}
      style={{
        borderRadius: "0.4rem",
        backgroundColor: "",
        alignItems: "center",
        display: "flex",
        height: "100%",
      }}
    >
      <DocumentVersionInCard
        key={index}
        version={version}
        members={projectData.membersOfProject}
        length={versionState.data.length}
        showModal={showModal}
        setDeleteversion={setDeleteversion}
        projectName={projectData?.name}
      />
    </motion.div>
  );
};

const FilteredData = ({
  view,
  versionData,
  listView,
  versionState,
  projectData,
  showModal,
  setDeleteversion,
  setScrollToBottom,
}: any) => {
  const { t } = useTranslation();
  const [isAnimate, setIsAnimate] = useState(false);

  const handlePageClick = (data: any) => {
    setCurrentPage(data.selected);
  };
  const pageSize = 15;
  const [currentPage, setCurrentPage] = useState(0);

  // Reset to first page when filtered data changes
  useEffect(() => {
    setCurrentPage(0);
  }, [versionData]);

  useEffect(() => {
    if (isNearOneMinute(new Date(versionData[0]?.createdAt))) {
      setScrollToBottom(true);
      setIsAnimate(true);
      setTimeout(() => {
        setIsAnimate(false);
      }, 1000);
    }
  }, [versionState]);

  if (versionData.length > 0) {
    if (!listView) {
      if (!view) {
        return (
          <>
            {versionData.map((version: Document, index: number) =>

              (version as any)?.version ? (
                isAnimate ? (
                  <VersionBox
                    key={index}
                    index={index}
                    version={version}
                    versionState={versionState}
                    setDeleteversion={setDeleteversion}
                    showModal={showModal}
                    projectData={projectData}
                  />
                ) : (

                  <DocumentVersionInCard
                    key={index}
                    version={version}
                    members={projectData.membersOfProject}
                    length={versionState.data.length}
                    showModal={showModal}
                    setDeleteversion={setDeleteversion}
                    projectName={projectData?.name}
                  />
                )
              ) : null
            )}
          </>
        );
      } else {
        return (
          <div className="container" style={{ backgroundColor: "inherit" }}>
            <div className="stack">
              {versionData
                .slice(currentPage * pageSize, (currentPage + 1) * pageSize)
                .map((version: Document, index: any) =>
                  (version as any)?.version ? (
                    <DocumentVersionInCard
                      key={version.documentId || `version-${index}`}
                      version={version}
                      members={projectData.membersOfProject} //todo: members
                      length={versionState.data.length}
                      showModal={showModal}
                      setDeleteversion={setDeleteversion}
                      projectName={projectData?.name}
                    />
                  ) : null
                )}
            </div>

            {versionData.length > pageSize && (
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={Math.ceil(versionData.length / pageSize)}
                marginPagesDisplayed={1}
                pageRangeDisplayed={1}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            )}
          </div>
        );
      }
    } else {
      return (
        <VerticalStack
          style={{
            alignSelf: "flex-start",
            width: "100%",
            height: view ? "" : "21.3rem",
            overflowY: view ? "visible" : "scroll",
            borderRadius: "8px",
            padding: "10px",
            gap: "10px",
            backgroundColor: "#E8ECF4",
            boxShadow: "0px 4px 10px 0px #0000001F",
            marginTop: "14px",
            marginBottom: "15px",
            marginLeft: "0.6%",
            marginRight: "0.6%",
            border: "1px solid #FFFFFF",
          }}
        >
          {versionData.map(
            (version: Document) =>
              (version as any)?.version && (
                <VersionsListView
                  key={version.documentId || `version-${version.version}`}
                  version={version}
                  view={view}
                  showModal={showModal}
                  length={versionState.data.length}
                  setDeleteversion={setDeleteversion}
                  projectName={projectData?.name}
                />
              )
          )}
        </VerticalStack>
      );
    }
  } else {
    return (
      <Stack style={styles.emptyContainer}>
        <Text style={{ ...styles.headerStyle, fontSize: "28px" }}>
          {t("no_versions_found")}
        </Text>
      </Stack>
    );
  }
};

interface VersionErrorProps {
  versionError: boolean;
  setVersionError: (error: boolean) => void;
  projectState: any;
  versionState: any;
}

const VersionError: React.FC<VersionErrorProps> = (props) => {
  const { versionError, setVersionError, projectState, versionState } = props;
  const { t } = useTranslation();
  if (
    !projectState.isLoading &&
    !versionState.isLoading &&
    versionState.error !== ""
  ) {
    return (
      <Stack className={mergeStyles(styles.errorStyles)}>
        <Text className={textStyles}>{t("loader")}</Text>
        <PrimaryButton
          styles={retryButtonStyles}
          onClick={() => setVersionError(!versionError)}
        >
          {t("retry")}
        </PrimaryButton>
      </Stack>
    );
  } else return null;
};

interface VersionUIProps {
  projectState: any;
  versionState: any;
  versionData: any[];
  view: boolean;
  listView: boolean;
  showModal: () => void;
  setDeleteversion: (version: any) => void;
  projectData: any;
  versionError: boolean;
  setVersionError: (error: boolean) => void;
  setScrollToBottom: React.Dispatch<React.SetStateAction<boolean>>;
  setRightArrowVisible?: (value: boolean) => void;
  setLeftArrowVisible?: (value: boolean) => void;
  selectedId?: number;
  versionsResolving?: boolean;
}

const VersionsUI: React.FC<VersionUIProps> = (props) => {
  const {
    projectState,
    versionState,
    versionData,
    view,
    listView,
    showModal,
    setDeleteversion,
    projectData,
    versionError,
    setVersionError,
    setScrollToBottom,
    setRightArrowVisible,
    setLeftArrowVisible,
    selectedId,
    versionsResolving,
  } = props;
  const { t } = useTranslation();
  if (!projectState.isLoading && versionState.isLoading) {
    return <LoaderJSX />;
  } else if (versionState.error !== "") {
    return (
      <VersionError
        versionError={versionError}
        setVersionError={setVersionError}
        projectState={projectState}
        versionState={versionState}
      />
    );
  } else if (versionsResolving) {
    // DEX-573 M2: the selected document's versions aren't in the store yet (a doc
    // or project switch is in flight, or a selection is imminent while the doc list
    // loads). Show the loader — never the previous doc's versions or an empty flash.
    return <LoaderJSX />;
  } else if (projectState.data?.documents?.length === 0 || versionData.length === 0) {
    return (
      <Stack className={mergeStyles(styles.errorStyles)}>
        <Text className={textStyles}>{t("no_versions_found")}</Text>
      </Stack>
    );
  } else if (
    !versionState.isLoading &&
    versionData.length !== 0 &&
    (versionData[0] as any)?.rootDocumentId === selectedId
  ) {
    return (
      <FilteredData
        view={view}
        versionData={versionData}
        listView={listView}
        versionState={versionState}
        projectData={projectData}
        showModal={showModal}
        setDeleteversion={setDeleteversion}
        setScrollToBottom={setScrollToBottom}
      />
    );
  } else return null;
};

const DEFAULT_VERSION_STATE = { data: [], isLoading: false, error: "" };

export const VersionsInDoc: FC<any> = (props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [versionData, setVersionData] = useState<Document[]>([]);
  const [filteredVersionData, setFilteredVersionData] = useState<Document[]>([]);
  const [listView, setListView] = useState<boolean>(false);
  const [filter, setFilter] = useState<boolean>(false);
  const [filterOption, setFilterOption] = useState<number>(0);
  const [view, setView] = useState<boolean>(false);
  const { isModalOpen, showModal, hideModal } = useModal();
  const [deleteVersion, setDeleteversion] = useState<Document>();
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(5);
  const prevVersionDataRef = useRef<Document[]>([]);
  const prevSelectedIdRef = useRef<number | undefined>(undefined);

  const totalSlides = filteredVersionData.length;
  const showPrevArrow = currentSlide > 0;
  const showNextArrow = currentSlide < totalSlides - slidesToShow;


  useEffect(() => {
    const calculateSlidesToShow = () => {
      try {
        const windowWidth = window.innerWidth;
        
        if (windowWidth < 550) {
          setSlidesToShow(1);
        } else if (windowWidth < 790) {
          setSlidesToShow(2);
        } else if (windowWidth < 1027) {
          setSlidesToShow(3);
        } else if (windowWidth < 1280) {
          setSlidesToShow(4);
        } else {
          setSlidesToShow(5);
        }
      } catch (error) {
        console.error('Error calculating slides to show:', error);
      }
    };

    calculateSlidesToShow();
    window.addEventListener('resize', calculateSlidesToShow);
    return () => window.removeEventListener('resize', calculateSlidesToShow);
  }, []);
  

  const filterOptions = [
    t("all_documents"),
    t("draft_docs_only"),
    t("received_docs_only"),
    t("sent_docs_only"),
  ];
  
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    arrows: true,
    afterChange: (index: number) => setCurrentSlide(index),
    prevArrow: showPrevArrow ? <PrevArrow className="prevArrow" /> : undefined,
    nextArrow: showNextArrow ? <NextArrow className="nextArrow" /> : undefined,
  };

  useEffect(() => {
    setCurrentSlide(0);
  }, [versionData.length, filterOption]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  const projectState = useAppSelector(
    (state: { fetchProjectDetails: any }) => state.fetchProjectDetails
  );

  const versionState = useAppSelector(
    (state) => {
      if (!props?.selectedId || props.selectedId === 0) {
        return DEFAULT_VERSION_STATE;
      }

      return debouncedSearchText.length === 0
        ? state.fetchDocumentVersion
        : state.fetchSearchedVersions;
    }
  );

  const projectDocumentsState = useAppSelector(
    (state: { fetchProjectDocuments: any }) => state.fetchProjectDocuments
  );

  // DEX-573 M2: is the version list for the current selection still resolving?
  // True while a document (or project) switch is in flight so we render the loader
  // instead of the previous doc's versions or a "no versions" flash. Only when not
  // searching — an active search can legitimately return an empty result.
  const hasSelection = !!props?.selectedId && props.selectedId !== 0;
  const currentDocuments: any[] = Array.isArray(props?.documents)
    ? props.documents
    : [];
  const documentsProvided = currentDocuments.length > 0;
  // The selected id belongs to the CURRENT project's document list. On a project
  // switch, `selectedId` still points at the previous project's document (and the
  // store still holds its versions, so a plain slice match would pass) until the
  // new document list loads — this catches that stale selection.
  const selectedDocIsCurrent =
    hasSelection &&
    currentDocuments.some((d: any) => d?.rootDocumentId === props?.selectedId);
  const sliceMatchesSelection =
    hasSelection &&
    Array.isArray(versionState.data) &&
    versionState.data.length > 0 &&
    (versionState.data[0] as any)?.rootDocumentId === props?.selectedId;
  // The loaded versions carry their own projectId — if it disagrees with the
  // current project, they belong to the project we just navigated away from.
  const versionsProjectId =
    Array.isArray(versionState.data) && versionState.data.length > 0
      ? (versionState.data[0] as any)?.projectId
      : undefined;
  const versionsFromAnotherProject =
    versionsProjectId != null &&
    props?.projectData?.id != null &&
    versionsProjectId !== props.projectData.id;
  const selectionImminent =
    !hasSelection &&
    (!!projectDocumentsState?.isLoading ||
      documentsProvided ||
      (Array.isArray(projectDocumentsState?.data) &&
        projectDocumentsState.data.length > 0));
  const versionsResolving =
    debouncedSearchText.length === 0 &&
    (selectionImminent ||
      versionsFromAnotherProject ||
      (hasSelection && !sliceMatchesSelection) ||
      (hasSelection && documentsProvided && !selectedDocIsCurrent) ||
      (hasSelection &&
        !!projectDocumentsState?.isLoading &&
        !selectedDocIsCurrent));

  // Reset search + local list when the selected document changes. Layout effect so
  // it runs before the sync/filter layout effects below (source order) and never
  // clobbers a freshly-synced list after paint (DEX-573).
  useLayoutEffect(() => {
    setSearchText("");
    setDebouncedSearchText("");
    setVersionData([]);
  }, [props?.selectedId]);

  useEffect(() => {
    if (debouncedSearchText.length && props?.selectedId && props.selectedId !== 0) {
      const cleanedSearch = /^[vV]\d/.test(debouncedSearchText)
        ? debouncedSearchText.slice(1)
        : debouncedSearchText;
      dispatch(
        getSearchedVersions({
          rootDocumentId: props.selectedId,
          searchParam: cleanedSearch,
          limit: 50,
          offset: 0,
        })
      );
    }
  }, [debouncedSearchText, dispatch, props?.selectedId]);

  // Sync the local version list from the store before paint (useLayoutEffect) so a
  // freshly-loaded document's versions never lag a frame behind the store (DEX-573).
  useLayoutEffect(() => {
    const selectedIdChanged = prevSelectedIdRef.current !== props?.selectedId;

    if (selectedIdChanged) {
      prevSelectedIdRef.current = props?.selectedId;
    }

    if (
      props?.selectedId &&
      props.selectedId !== 0 &&
      versionState.data &&
      versionState.data.length > 0 &&
      versionState.data[0]?.rootDocumentId === props?.selectedId
    ) {
      const dataChanged = 
        selectedIdChanged ||
        prevVersionDataRef.current.length !== versionState.data.length ||
        prevVersionDataRef.current.length === 0 ||
        (prevVersionDataRef.current[0] as any)?.id !== (versionState.data[0] as any)?.id;
      
      if (dataChanged) {
        setVersionData(versionState.data);
        prevVersionDataRef.current = versionState.data;
      }
    } else if (!props?.selectedId || props.selectedId === 0) {
      if (prevVersionDataRef.current.length > 0) {
        setVersionData([]);
        prevVersionDataRef.current = [];
      }
    }
  }, [versionState.data, props?.selectedId]);

  // Filter versionData based on filterOption. Layout effect so the filtered list is
  // in sync with versionData within the same frame — no empty/stale flash (DEX-573).
  useLayoutEffect(() => {
    const filtered = versionData.filter((version: Document) => {
      const matchesType =
        filterOption === 1 ? version.fileType === "draft" :
        filterOption === 2 ? version.fileType === "received" :
        filterOption === 3 ? version.fileType === "sent" :
        true;

      const matchesSearch = debouncedSearchText.length === 0 || (() => {
        const search = debouncedSearchText.replace(/^[vV]/, "").toLowerCase();
        const sd = version.shareDetails;
        const replyName = sd?.reply
          ? `${sd.reply.firstName ?? ""} ${sd.reply.lastName ?? ""}`.trim().toLowerCase()
          : "";
        const replyAllNames = sd?.replyAll
          ? sd.replyAll.map(u => `${u.firstName ?? ""} ${u.lastName ?? ""}`).join(" ").toLowerCase()
          : "";
        return (
          String((version as any).version).includes(search) ||
          version.fileType?.toLowerCase().includes(search) ||
          version.projectOwnerName?.toLowerCase().includes(search) ||
          version.createdAt?.toLowerCase().includes(search) ||
          (version as any).metadata?.driveItemName?.toLowerCase().includes(search) ||
          sd?.subject?.toLowerCase().includes(search) ||
          sd?.emailNotes?.toLowerCase().includes(search) ||
          replyName.includes(search) ||
          replyAllNames.includes(search)
        );
      })();

      return matchesType && matchesSearch;
    });
    setFilteredVersionData(filtered);
  }, [filterOption, versionData, debouncedSearchText]);

  return (
    <>
      <Stack
        className={mergeStyles({
          ...styles.versionContainer,
          position: "relative",
        })}
      >
        <HorizontalStack horizontalAlign="space-between">
          <HorizontalStack
            horizontalAlign="space-between"
            className="HeaderStack"
          >
            <VerticalStack style={{ width: "100%", zIndex: 5 }}>
              <HorizontalStack className="HeaderStackContent" >
                <HorizontalStack className="HeaderStackContentTitleVersions">
                  <HandShakeIcon />
                  <Text style={styles.headerStyle}>
                    {!versionState.isLoading &&
                      !versionsResolving &&
                      getSplitDocumentName(props.selectedDocument)}
                  </Text>
                </HorizontalStack>
                <SearchComp
                  searchText={searchText}
                  setSearchText={setSearchText}
                  listView={listView}
                  setListView={setListView}
                  filter={filter}
                  setFilter={setFilter}
                  filterOption={filterOption}
                  setFilterOption={setFilterOption}
                  filterOptions={filterOptions}
                />
              </HorizontalStack>
              <HorizontalStack style={{ alignItems: "center" }} >
                <Text style={styles.DocNameStyle}>
                  {t("document_history")}
                </Text>
                {!listView && filteredVersionData && filteredVersionData.length > 0 && (versionData[0] as any)?.rootDocumentId === props?.selectedId && (
                  <ViewAll
                    onClickFunction={() => {
                      setView(!view);
                    }}
                    collapsed={view}
                  />
                )}
              </HorizontalStack>
            </VerticalStack>
          </HorizontalStack>
        </HorizontalStack>
        {!versionsResolving && filteredVersionData && filteredVersionData.length > 0 && !view && !listView && props?.selectedId && props.selectedId !== 0 && (versionData[0] as any)?.rootDocumentId === props?.selectedId ? (
            <div className={mergeStyles(styles.versionCard)} id="myVersionStack" style={{overflow: "visible"}}>
              <Slider
              key={`slider-${props.selectedId}-${filteredVersionData.length}`}
              {...settings}>
                {filteredVersionData.map((version: Document, id: number) =>
                  (version as any)?.version ? (
                    <div
                        key={(version as any).id || id}
                        style={{
                          padding: "0 10px",
                          boxSizing: "border-box",
                          width: "100%",
                        }}
                      >
                      <DocumentVersionInCard
                        version={version}
                        members={props?.projectData?.members} //todo: membersOfProject
                        length={filteredVersionData.length}
                        showModal={showModal}
                        setDeleteversion={setDeleteversion}
                        projectName={props?.projectData?.name}
                      />
                    </div>
                  ) : null
                )}
              </Slider>
            </div>
        ) : (
          <HorizontalStack
            className={mergeStyles(styles.expandedDocumentContainer)}
          >
            <VersionsUI
              view={view}
              listView={listView}
              projectData={props?.projectData}
              projectState={projectState}
              showModal={showModal}
              setDeleteversion={setDeleteversion}
              setVersionError={props?.setVersionError}
              versionError={props?.versionError}
              versionData={filteredVersionData}
              versionState={versionState}
              setScrollToBottom={props?.setScrollToBottom}
              selectedId={props?.selectedId}
              versionsResolving={versionsResolving}
            />
          </HorizontalStack>
        )}
      </Stack>
      <DeleteVersionModal
        isModalOpen={isModalOpen}
        showModal={showModal}
        hideModal={hideModal}
        version={deleteVersion}
        refresh={props.refresh}
      />
    </>
  );
};
